//@flow
import React from 'react';
import InfoBar from './info-bar';

import {
  Container
} from 'flux/utils';
import css from './info-bar.css';

import appStore from 'app/store';
// import Loading from 'lib/Loading';

import {
  QueryRenderer,
  graphql
} from 'react-relay';
import env from 'app/relay/environment';



const rootQuery = (graphql `query infoBarContainer_GetInfobar_Query {
  user{
    id
    isAdmin
    person
    {email id profilePicture firstname lastname}
  }
}
`);

type Props = {
  location: Object
}
type State = {
  appStore: Object
}

class InfoBarContainer extends React.Component < Props, State > {

  static getStores() {
    return [appStore];
  }

  static calculateState(prevState) {
    return {
      appStore: appStore.getState()
    };
  }


  render() {
    // const brand = this.state.appStore.get("brand");

    return <QueryRenderer
      environment={env}
      query={rootQuery}

      render={({error, props}) => {
        if (error) {
          return <div>{error.message}</div>;
        } else if (props) {
          return <InfoBar data={props} {...this.props}/>;
  } else {
    return <div className={css.infobar}></div>
  }
}
}
/>
}
}
// export default InfoBarContainer
export default Container.create(InfoBarContainer);